module.exports = __webpack_public_path__ + "assets/media/arrow-right.f5e26d2b.svg";